export class Data {
    data = [];
    constructor() {
        this.getDummyData = this.getDummyData.bind(this);
        this.getDummyDataItem = this.getDummyDataItem.bind(this);
        this.tryLogin = this.tryLogin.bind(this);
        this.postVerify = this.postVerify.bind(this);
        this.postVerifyReset = this.postVerifyReset.bind(this);
        this.postVerifyResetPassword = this.postVerifyResetPassword.bind(this);
        this.postRegister = this.postRegister.bind(this);
        this.sourceServer = 'https://localhost:44374';
        this.getIdentity = this.getIdentity.bind(this);
        this.getSsnId = this.getSsnId.bind(this);
        this.getDistricts = this.getDistricts.bind(this);
        this.performNetworkActivation = this.performNetworkActivation.bind(this);
        this.performAccountActivation = this.performAccountActivation.bind(this);
        this.performAuthenticatedFetch = this.performAuthenticatedFetch.bind(this);
        this.performAuthenticatedCorsFetch = this.performAuthenticatedCorsFetch.bind(this);
        this.postPasswordReset = this.postPasswordReset.bind(this);
        this.getUserId = this.getUserId.bind(this);
    }

    performAuthenticatedCorsFetch(resourceUrl) {
        if (!this.isTokenValid()) {
            return window.location = "/login"
        }

        var accesstoken = localStorage.getItem('accesstoken');

        return fetch(resourceUrl, {
            headers: {
                'Access-Control-Allow-Origin': this.sourceServer,
                'Authorization': "Bearer " + accesstoken
            },
            mode: "cors"
        }).then((data) => {
            return data.json();
        }).catch((error) => { console.log(error) });
    }

    performAuthenticatedFetch(resourceUrl) {
        if (!this.isTokenValid()) {
            window.location = "/login";
            return Promise.reject(new Error("Unable to get accesstoken"));
        }

        const accessToken = localStorage.getItem('accesstoken');
        return this.performDataFetch(accessToken, resourceUrl);
    }

    // TODO: Combine this with the above
    performAuthenticatedDownload(resourceUrl) {
        if (!this.isTokenValid()) {
            window.location = "/login";
            return Promise.reject(new Error("Unable to get accesstoken"));
        }
        const accessToken = localStorage.getItem('accesstoken');
        return fetch(resourceUrl, {
            headers: {
                'Authorization': "Bearer " + accessToken
            }
        });
    }

    performDataFetch(access_token, resourceUrl) {
        return fetch(resourceUrl, {
            headers: {
                'Authorization': "Bearer " + access_token
            }
        }).then((data) => {
            if (data.ok) return data.json();
            //todo: actually handle this error
            return {};
        });
    }

    performAuthenticatedDelete(resourceUrl) {
        if (!this.isTokenValid()) {
            return window.location = "/login"
        }
        const accessToken = localStorage.getItem('accesstoken');
        return fetch(resourceUrl, {
            method: 'DELETE',
            headers: {
                'Authorization': "Bearer " + accessToken
            }
        });
    }

    getDummyData() {
        return fetch(this.sourceServer + '/api/v1/dummy', {
            headers: {
                'Access-Control-Allow-Origin': this.sourceServer
            },
            mode: "cors"
        }).then(data => data.json());
    }

    getDummyDataItem(index) {
        return fetch('/api/dummy/dummydata?id=' + index).then(data => data.json());
    }

    // summary:  Authenticate a user 
    // parameter:  username - user name
    //             password - user password
    //             district - user district
    // return:  (Nothing)   

    tryLogin(username, password) {
        return fetch('/api/account/clientip')
            .then((res) => res.json())
            .then((ipjson) => {
                sessionStorage.setItem('ipaddress', ipjson);
                return fetch('/api/account/authenticate', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        username: username,
                        password: password,
                        ipaddress: ipjson
                    })
                })
                    .then((response) => response.json())
                    .then((responseJson) => {
                        if (responseJson
                            && typeof responseJson === 'object'
                            && responseJson.statusCode === 400) {
                            throw new Error("Login failed.  " + responseJson.value);
                        }
                        else {
                            localStorage.setItem('accesstoken', responseJson.token);
                            sessionStorage.setItem('username', username);
                            window.location = "/myphoenix"
                        }
                    });
            });
    }

    // summary:  Verify user personal information for registration
    // parameter:  pin - user eportal pin
    //             ssn - user social security
    //             dateofbirth - user birth day
    //             zipcode - user zip code
    //             districtno - user district
    // return:  (Nothing)   

    postVerify(pin, ssn, dateofbirth, zipcode, districtno) {
        return fetch('/api/account/verify', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                PIN: pin,
                SSN: ssn,
                DateOfBirth: dateofbirth,
                Zip: zipcode,
                District: districtno
            })
        })
            .then((response) => response.json())
            .then((responseJson) => {
                if (responseJson
                    && typeof responseJson === 'object'
                    && responseJson.statusCode === 400) {
                    /*throw new Error("Failed to verify information.");*/
                    throw new Error(responseJson.value);
                }
                else {
                    sessionStorage.setItem('SsnId', responseJson.ssnId)
                    sessionStorage.setItem('EmployeeName', responseJson.employeeName)
                    localStorage.setItem('District', responseJson.district)
                    window.location = "/register"
                }
            });
    }

    // summary:     Post to the specified API or resource url 
    // parameters:  API - API (resource) url
    //              jsonstring - JSON String
    // return:      The JSON object   

    postFetchAPI(API, jsonstring) {
        return fetch(API, {
            method: 'POST',
            headers: {
                'Content-type': 'application/json'
            },
            body: jsonstring
        })
            .then((response) => response.json())
            .catch(function (e) { console.error(e) });
    }

    performAuthenticatedPostAPI(API, jsonstring) {
        var accesstoken = localStorage.getItem('accesstoken');
        if (!accesstoken) {
            window.location = "/login"
        }
        return fetch(API, {
            method: 'POST',
            headers: {
                'Content-type': 'application/json',
                'Authorization': 'Bearer ' + accesstoken
            },
            body: jsonstring
        })
            .catch(function (e) { console.error(e) });
    }

    // summary:  Verify user personal information 
    // parameter:  pin - user eportal pin
    //             dateofbirth - user birth day
    //             zipcode - user zip code
    //             districtno - user district
    // return:  (Nothing)   
    postVerifyReset(pin, ssn, dateofbirth, zipcode, districtno) {
        var bodyjsonstring = JSON.stringify({
            PIN: pin,
            SSN: ssn,
            DateOfBirth: dateofbirth,
            Zip: zipcode,
            District: districtno
        });

        return this.postFetchAPI('/api/account/verifyreset', bodyjsonstring)
            .then((responseJson) => {
                if (responseJson
                    && typeof responseJson === 'object'
                    && responseJson.statusCode === 400) {
                    throw new Error("Failed to verify information for password reset:  "
                        + responseJson.value);
                }
                else {
                    sessionStorage.setItem('SsnId', responseJson.ssnId)
                    sessionStorage.setItem('EmployeeName', responseJson.employeeName)
                    localStorage.setItem('District', responseJson.district)
                    window.location = "/verifyresetpassword"
                }
            });
    }

    // summary:  Reset password verification  
    // parameter:  answer1 - answer to security question 1
    //             answer2 - answer to security question 2
    //             answer3 - answer to security question 3
    // return:  (Nothing)   
    postVerifyResetPassword(answer1, answer2, answer3) {
        return fetch('/api/account/verifyresetpassword', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                SsnId: sessionStorage.getItem('SsnId'),
                Answer1: answer1,
                Answer2: answer2,
                Answer3: answer3,
                Districtno: localStorage.getItem('District'),
                Email: sessionStorage.getItem('Email'),
                EmployeeName: sessionStorage.getItem('EmployeeName')
            })
        })
            .then((response) => response.json())
            .then((responseJson) => {
                if (responseJson
                    && typeof responseJson === 'object'
                    && responseJson.statusCode === 400) {
                    throw new Error("Failed to verify security answers:  "
                        + responseJson.value + "  Please try again.");
                }
                else {
                    window.location = "/resetpasswordsuccess"
                }
            });
    }

    // summary:  Register a new user  
    // parameter:  username - user name 
    //             password - user password 
    //             email - user email 
    //             answer1 - answer to security question 1
    //             answer2 - answer to security question 2
    //             answer3 - answer to security question 3
    //             question1 - security question 1 ID
    //             question2 - security question 2 ID
    //             question3 - security question 3 ID
    // return:  (Nothing)   
    postRegister(username, password, email, answer1, answer2, answer3, question1, question2, question3) {
        return fetch('/api/account/register', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                DistictNo: localStorage.getItem('District'),
                SsnId: sessionStorage.getItem('SsnId'),
                Username: username,
                Password: password,
                Email: email,
                QuestionId1: question1,
                Answer1: answer1,
                QuestionId2: question2,
                Answer2: answer2,
                QuestionId3: question3,
                Answer3: answer3,
                IpAddress: '',
                DeviceName: '',
                EmployeeName: sessionStorage.getItem('EmployeeName')
            })
        })
            .then((response) => response.json())
            .then((responseJson) => {
                if (responseJson
                    && typeof responseJson === 'object'
                    && responseJson.statusCode === 400) {
                    throw new Error(responseJson.value)
                }
                else {
                    window.location = "/registrationcomplete"
                }
            });
    }

    getIdentity() {
        return this.performAuthenticatedCorsFetch('https://dev-api-phx.tcoe.org/api/v1/identity');
    }

    // summary:  Activate account action  
    // parameter:  activationcode - activation code ID
    // return:  (Nothing)   
    performAccountActivation(activationcode) {
        var apiUrl = '/api/account/accountactivation?id=' + activationcode;
        return fetch(apiUrl, { method: 'POST' }).then((response) => response.json())
            .then((responseJson) => {
                var res = JSON.parse(responseJson);
                if (res && res.status === 400) {
                    console.error('Error - Failed to activate accpimt.');
                    return res.value;
                }
                else {
                    window.location = "/login";
                }
            }).catch(function (e) { console.error(e) });
    }

    // summary:  Activate network action  
    // parameter:  activationcode - activation code ID
    // return:  (Nothing)               
    performNetworkActivation(activationcode) {
        var apiUrl = '/api/account/networkactivation?id=' + activationcode;
        return fetch(apiUrl, { method: 'POST' }).then((response) => response.json())
            .then((responseJson) => {
                var res = JSON.parse(responseJson);
                if (res && res.status === 400) {
                    console.error('Error - Failed to activate network.')
                    return "Failed to activate network.";
                }
                else {
                    window.location = "/login";
                }
            }).catch(function (e) { console.error(e) });
    }
    getUser() {
        return this.performAuthenticatedFetch('/api/user/self');
    }

    getEmployee() {
        const ssnid = this.getSsnId();
        const districtno = localStorage.getItem('District');
        return this.performAuthenticatedFetch('/api/employee?ssnId=' + ssnid + '&districtno=' + districtno);
    }

    getDistricts() {
        // TODO: Clean this up
        const ssnid = this.getSsnId();
        return this.performAuthenticatedFetch('/api/district/employeeDistricts?ssnId=' + ssnid);
    }

    getAllDistricts() {
        return fetch('/api/district/districts')
            .then((response) => {
                if (response.ok) {
                    return response.json();
                }
            })
            .catch(function () {
                return Promise.reject(new Error("Unable to get the districts"));
            });
    }

    getDistrictSettings() {
        const districtno = localStorage.getItem('District');

        return fetch('/api/district/districtsettings?districtNo=' + districtno)
            .then((response) => {
                if (response.ok) {
                    return response.json();
                }
            })
            .catch(function () {
                return Promise.reject(new Error("Unable to get district settings for districtNo: " + districtno));
            });
    }

    // summary:  Get security questions or only the security questions for the specified social security ID.  
    // parameter:  ssnid - social security ID
    // return:  Questions for social security ID               
    getQuestions(ssnid) {
        var apiUrl = '/api/account/securityquestions'
        if (ssnid) {
            apiUrl = '/api/account/questions?ssnid=' + ssnid;
        }

        return fetch(apiUrl).then((response) => response.json())
            .then((responseJson) => {
                if (responseJson && responseJson.status === 400) {
                    console.error('Error - Failed to security questions.')
                }
                else {
                    if (ssnid) {
                        sessionStorage.setItem('Email', responseJson.email);
                    }

                    return responseJson;
                }
            }).catch(function (e) { console.error(e) });
    }

    getResetPasswordActivationInfo(activationcode) {
        return fetch('/api/account/passwordresetactivation?activationCode=' + activationcode)
            .then((response) => {
                if (response.statusCode !== 400) {
                    return response.json();
                }

                return 'InvalidActivationCode'
            }).catch(function (e) { console.error(e) });
    }

    // summary:  Reset password
    // parameter:  userid - user id
    //             password - new user password
    // return:  (Nothing)   
    postPasswordReset(userid, password) {
        return fetch('/api/account/resetpassword', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                UserId: userid,
                Password: password
            })
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error("Failed to reset password.");
                }
                else {
                    window.location = "/passwordresetcomplete"
                }
            });
    }

    isTokenValid() {
        const expireTime = this.getTokenValue('exp')
        const currentTime = Math.floor(Date.now() / 1000);
        if (expireTime && ((expireTime - currentTime) > 0)) {
            return true;
        }
        localStorage.removeItem('accesstoken');
        return false;
    }

    getTokenValue(key) {
        const token = this.parseJwt();
        if (token) {
            const value = token[key];
            return value;
        }
        return null;
    }

    // TODO: Add error handling
    getSsnId() {
        var ssnid = this.getTokenValue('http://schemas.tcoe.org/ws/2019/01/identity/claims/SID');
        return ssnid;
    }

    getUserId() {
        var userid = this.getTokenValue('nameid');
        return userid;
    }

    // TODO: Add error handling
    parseJwt() {
        const token = localStorage.getItem('accesstoken');
        if (!token) { return null; }
        // Get payload data
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        return JSON.parse(window.atob(base64));
    };    
}
